// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1Vm6A","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1qYr1","obliqueLine":"membershipbadge_obliqueLine__4mD11"};